<!-- 宿迁民丰加油满减活动页 内嵌民丰小程序打开 -->
<template>
  <div class="minfeng-bank-suqian-refuel-index-page">
    <div class="seat"></div>
    <div class="receive-box">
      <h4>——请根据民丰卡类型选择一张领取——</h4>
      <div class="content">
        <div class="row left-row">
          <img
            v-if="btnMap[creditCheckResultType]"
            class="btn"
            :src="btnMap[creditCheckResultType]"
            alt=""
            @click="receive(1, creditCheckResultType)"
          />
        </div>
        <!-- <div class="row right-row">
          <img
            v-if="btnMap[socialSecurityCheckResultType]"
            class="btn"
            :src="btnMap[socialSecurityCheckResultType]"
            alt=""
            @click="receive(2, socialSecurityCheckResultType)"
          />
        </div> -->
      </div>
      <p>仅限宿迁市内中石化加油站使用</p>
      <!-- <img
        class="pic"
        :src="require(`@/assets/imgs/minfengBankSuqianRefuel/pic10.png`)"
        alt=""
      />
  
      <img
        v-if="btnMap[checkResultType]"
        class="btn"
        :src="btnMap[checkResultType]"
        alt=""
        @click="receive"
      /> -->
    </div>
    <div class="rule-box">
      <img
        class="pic"
        :src="require(`@/assets/imgs/minfengBankSuqianRefuel/pic13.png`)"
        alt=""
      />
    </div>

    <p class="footer">最终解释权归江苏民丰农商银行所有，咨询电话：4001096008</p>

    <!-- <p @click="btn1">成功</p>
    <p @click="btn2">失败</p>
    <p @click="btn3">错误信息</p> -->

    <!-- 结果弹窗 -->
    <ResultPopup ref="resultPopupRef" />
  </div>
</template>
<script>
import { login, check, issuingVouchers, addPointData } from '@/api/minfengBank.js'
import ResultPopup from './components/ResultPopup.vue'
import { Toast } from 'vant'
export default {
  components: {
    ResultPopup,
  },
  data() {
    return {
      title: '民丰银行',
      btnDisable: false, // 领取中
      errorMsg: '', // 登录失败提示
      checkResultType: '', // 活动结果状态
      creditCheckResultType: '', // 信用卡按钮状态
      socialSecurityCheckResultType: '', // 社保卡按钮状态
      btnMap: {
        L1: require(`@/assets/imgs/minfengBankSuqianRefuel/slbtn1.png`), // 立即领取
        1: require(`@/assets/imgs/minfengBankSuqianRefuel/sbtn1.png`), // 立即领取
        2: require(`@/assets/imgs/minfengBankSuqianRefuel/sbtn2.png`), // 已领取
        3: require(`@/assets/imgs/minfengBankSuqianRefuel/sbtn3.png`), // 已抢光
        4: require(`@/assets/imgs/minfengBankSuqianRefuel/sbtn4.png`), // 立即领取-灰
      },
      urlToken: undefined,

    }
  },
  async created() {
    // this.urlToken = this.$route.query.urlToken.replace(/%20|\s/g, '%2B')
    this.urlToken = this.$route.query.urlToken
    if (sessionStorage.getItem('minfengBankRecordToken')) {
      this.getUserInfo()
    } else {
      this.login()
    }
    //首页回退禁用
    history.pushState(null, null, document.URL)

    window.addEventListener('popstate', this.popstatehandle, false) // 首页禁止回退
    window.addEventListener('pagehide', this.popstatehandle, false) // 首页禁止回退
  },
  mounted() {
  },
  methods: {
    popstatehandle() {
      history.pushState(null, null, document.URL)
      if (this.isWechat()) {
        // eslint-disable-next-line
        wx.closeWindow();
        //微信
        let path = '/pages/mfLife/mfLifeV2'  // 2024-12-23合作方需求更改
        // let path = '/pages/mfLife/mfLife'
        // let path = '/pages/index/index'
        // eslint-disable-next-line no-undef
        wx.miniProgram.reLaunch({ url: path });
      } else {
        window.close()
      }
    },
    isWechat() {
      return /MicroMessenger/i.test(window.navigator.userAgent);
    },
    login() {
      login({
        urlToken: this.urlToken,
        code: sessionStorage.getItem('ydsh-ph-h5-bankv3-wxcode')
      }).then(res => {
        if (res.code === 0) {
          sessionStorage.setItem('minfengBankRecordToken', res.data.token)
          this.checkResultType = res.data.checkResultType
          this.setBtnType(res.data)
          this.errorMsg = res.data.buttonText
          this.isOpenError()
          this.addPointData()
        } else {
          this.openError(res.message)
        }
      })
    },
    // 埋点
    addPointData() {
      addPointData({
        urlToken: this.urlToken,
      }).then(() => {

      })
    },
    // 社保卡领取状态，1-立即领取，2-已领取，3-已抢光
    // 信用卡领取状态，1-立即领取，2-已领取，3-已抢光
    setBtnType(data) {
      let { socialSecurityCardCode, creditCardCode, } = data
      let _creditCheckResultType = creditCardCode
      let _socialSecurityCheckResultType = socialSecurityCardCode

      let cardType = this.$route.query.cardType
      // -若cardType=1：仅信用卡领取按钮可点击
      // -若cardType=2：仅社保卡领取按钮可点击
      // -若cardType=3：信用卡&社保卡按钮均可点击
      switch (cardType) {
        case '1':
          _creditCheckResultType = 1
          _socialSecurityCheckResultType = 4
          break;
        case '2':
          _creditCheckResultType = 4
          _socialSecurityCheckResultType = 1
          break;
        case '3':
          _creditCheckResultType = 1
          _socialSecurityCheckResultType = 1
          break;
        default:
          _creditCheckResultType = 4
          _socialSecurityCheckResultType = 4
          break;
      }

      // 如果当前券还有剩余数量
      if (creditCardCode !== 3) {
        // _creditCheckResultType = socialSecurityCardCode === 2 ? 4 : creditCardCode
        if (socialSecurityCardCode === 2) {
          // 一个按钮已领取，另外一个按钮变成“立即领取-灰”
          _creditCheckResultType = 4
        } else {
          if (creditCardCode === 2) {
            // 当前按钮已领取
            _creditCheckResultType = creditCardCode
          }
          // 否则，按钮就是路由参数cardType决定
        }
      } else {
        // 已抢光
        _creditCheckResultType = creditCardCode
      }
      // 如果当前券还有剩余数量
      if (socialSecurityCardCode !== 3) {
        // _socialSecurityCheckResultType = creditCardCode === 2 ? 4 : socialSecurityCardCode
        if (creditCardCode === 2) {
          // 一个按钮已领取，另外一个按钮变成“立即领取-灰”
          _socialSecurityCheckResultType = 4
        } else {
          if (socialSecurityCardCode === 2) {
            // 当前按钮已领取
            _socialSecurityCheckResultType = socialSecurityCardCode
          }
          // 否则，按钮就是路由参数cardType决定
        }
      } else {
        // 已抢光
        _socialSecurityCheckResultType = socialSecurityCardCode
      }

      if (_creditCheckResultType === 1) _creditCheckResultType = 'L1' // 信用卡立即领取使用红色领取按钮
      this.creditCheckResultType = _creditCheckResultType
      this.socialSecurityCheckResultType = _socialSecurityCheckResultType
    },
    // 根据状态显示错误弹窗
    isOpenError() {
      // 校验结果类型，0-校验成功，1-活动链接异常，2-链接已失效，请重新进入，3-活动已结束，4-已领取，5-已抢光
      let cardType = this.$route.query.cardType
      // console.log(cardType, 'cardType==');
      if (cardType === '0') {
        return this.openError('未查询到您名下有我行信用卡或社保卡,请联系您的客户经理')
      }
      let successKeys = [0, 4, 5]
      if (successKeys.includes(this.checkResultType)) {
        console.log('正常状态');
      } else {
        this.openError(this.errorMsg)
      }
    },
    getUserInfo() {
      check({ urlToken: this.urlToken }).then(res => {
        if (res.code === 0) {
          this.checkResultType = res.data.checkResultCode
          this.setBtnType(res.data)
          this.errorMsg = res.data.msg
          this.isOpenError()
        }
      })
    },
    receive(type, btnType) {
      // "type", value = "领取类型，1-信用卡，2-社保卡"
      if (!["L1", 1].includes(btnType)) {
        return console.log(btnType, '--不满足条件');
      }
      if (this.btnDisable) {
        return Toast('领取中，请勿重复点击')
      }
      this.btnDisable = true
      issuingVouchers({
        urlToken: this.urlToken,
        type: type,
      }).then(res => {
        this.btnDisable = false
        if (res.code === 0) {
          let { checkResultCode, couponResults, msg } = res.data
          this.setBtnType(res.data)
          if (couponResults === 1) { // 当成已领取
            this.checkResultType = 4
            this.openSccess()
          } else {
            this.checkResultType = checkResultCode || 0
            this.openFail(msg)
          }
        }
      }).catch((res) => {
        this.btnDisable = false
      })
    },
    // 领取成功，可关闭
    openSccess() {
      this.$refs.resultPopupRef.message = '可在微信-卡包中查看'
      this.$refs.resultPopupRef.title = '领取成功'
      this.$refs.resultPopupRef.iconKey = '1'
      this.$refs.resultPopupRef.isClose = true
      this.$refs.resultPopupRef.show = true
    },
    // 领取失败，可关闭
    openFail(val) {
      this.$refs.resultPopupRef.message = val
      this.$refs.resultPopupRef.title = '领取失败'
      this.$refs.resultPopupRef.iconKey = '0'
      this.$refs.resultPopupRef.isClose = true
      this.$refs.resultPopupRef.show = true
    },
    // 领取结果弹窗,不可关闭
    openError(val) {
      this.$refs.resultPopupRef.message = ''
      this.$refs.resultPopupRef.title = val
      this.$refs.resultPopupRef.iconKey = '0'
      this.$refs.resultPopupRef.isClose = true
      this.$refs.resultPopupRef.show = true
    },
    btn1() {
      this.openSccess()
    },
    btn2() {
      this.openFail('抱歉，已抢光')
    },
    btn3() {
      this.openError('活动已结束可在微信-卡包中查看')
    },
  },
}
</script>
<style lang="less" scoped>
.minfeng-bank-suqian-refuel-index-page {
  background: url("../../../assets/imgs/minfengBankSuqianRefuel/pic8.jpg")
    no-repeat #fce7c1;
  background-size: 100% auto;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  font-size: 30px;
  .seat {
    width: 100%;
    height: 415px;
  }
  .receive-box {
    background: url("../../../assets/imgs/minfengBankSuqianRefuel/pic9.png")
      no-repeat;
    background-size: 100% 100%;
    text-align: center;
    padding: 10px 0 30px 0;
    h4 {
      font-weight: bold;
      font-size: 12px;
      color: #d7101e;
      padding: 16px 0;
    }
    .content {
      display: flex;
      justify-content: center;
    }
    .row {
      width: 123px;
      height: 176px;
      position: relative;
      .btn {
        position: absolute;
        left: 9%;
        bottom: 11px;
        width: 104px;
        height: 30px;
      }
    }

    .left-row {
      background: url("../../../assets/imgs/minfengBankSuqianRefuel/cbg1.png")
        no-repeat;
      background-size: 100% 100%;
    }
    .right-row {
      margin-left: 25px;
      background: url("../../../assets/imgs/minfengBankSuqianRefuel/cbg2.png")
        no-repeat;
      background-size: 100% 100%;
    }

    .pic {
      width: 300px;
    }
    .btn {
      width: 297px;
    }
    p {
      font-size: 12px;
      color: #9d746e;
      padding: 20px 0 12px 0;
    }
  }
  .rule-box {
    .pic {
      width: 100%;
    }
  }
  .footer {
    padding: 20px 0;
    font-size: 11px;
    color: #62594f;
    line-height: 16px;
    text-align: center;
  }
}
</style>
